import { render, staticRenderFns } from "./TeamPostsPage.vue?vue&type=template&id=2f251ac6&scoped=true&"
import script from "./TeamPostsPage.vue?vue&type=script&lang=js&"
export * from "./TeamPostsPage.vue?vue&type=script&lang=js&"
import style0 from "./TeamPostsPage.vue?vue&type=style&index=0&id=2f251ac6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f251ac6",
  null
  
)

export default component.exports